import { registryBaseUrl } from "@istari/istari-client";

import { resolveRegistryTarget } from "~/shared/config/registry-target";

/**
 * Base URL for raw registry fetches: `<gateway>/registry` when the gateway variable is set,
 * otherwise the direct registry host, otherwise localhost. Never carries a trailing slash.
 *
 * The `/registry` prefix is defined by the service-router Caddyfile and published by the SDK's
 * registryBaseUrl, so the frontend keeps no copy of it. SDK-backed clients do not use this —
 * they hand digitalApiUrl to the SDK, which applies the prefix internally.
 */
export function resolveRegistryBaseUrl(): string {
  const target = resolveRegistryTarget();
  return target.kind === "gateway" ? registryBaseUrl(target.digitalApiUrl) : target.registryUrl;
}
